import {React} from "react";
import PrivateLayout from "../components/layouts/PrivateLayout";
import Dashboard from "../modules/dashboard/dashboard";
import Profile from "../modules/account/profile/Profile";
import NotFound from "../components/notfound/NotFound";
import Activity from "../modules/activity/Activity";
import AdminDashboard from "../modules/dashboard/AdminDashboard";
// import CheckoutForm from "../modules/checkoutForm/CheckoutForm";
// import Dashboard from "../modules/dashboard/dashboard";
import PatientProfile from "../modules/patient/PatientProfile";
import Applications from "../modules/applications/Applications";
import Repository from "../modules/repository/Repository";
import PatientActivity from "../modules/activity/PatientActivity";
import Organization from "../modules/orgnization/Organization";
import AddOrganization from "../modules/orgnization/AddOrganization";
import AdminApplications from "../modules/applications/AdminApplications";
import ApplicationDetailPage from "../modules/applications/ApplicationDetailPage";
import PatientList from "../modules/patient/PatientList";
import AddClinic from "../modules/orgnization/AddClinic";
import Actions from "../modules/actions/Actions";
import AssignUser from "../modules/orgnization/AssignUser";
import Users from "../modules/users/Users";
import NotAuthorize from "../components/notfound/NotAuthorize";
import CreateUser from "../modules/users/user/CreateUser";
import Workflow from "../modules/workflow/Workflow";
import Cliniclisting from "../modules/orgnization/Cliniclisting";
import Userslisting from "../modules/orgnization/Userslisting";
import Messages from "../modules/messages/Messages";
import UserDetails from "../modules/users/user/UserDetails";
import RolesDetails from "../modules/users/roles/RolesDetails";
import OrganizationViewDetail from "../modules/orgnization/OrganizationViewDetail";
import ClinicViewDetail from "../modules/orgnization/ClinicViewDetail";
import { platformLayout } from "../utils/constants";
import Analytics from "../modules/analytics/Analytics";
import StartApplication from "../modules/applications/StartApplication";
import OrgUserDetails from "../modules/orgnization/UserDetails";
import Support from "../modules/support/Support";
import AddPatient from "../modules/patient/addpatient/AddPatient";
import EditProfile from "../modules/account/profile/EditProfile";
import ProfilePatient from "../modules/account/profile/PatientProfile";
import Calender from "../modules/actions/Calendar";
import SupportDetailsPage from "../modules/support/SupportDetailsPage";
import CreatePlatformRequest from "../modules/support/CreatePlatformSupportRequest";
import EditPatientProfile from "../modules/patient/EditPatientProfile";
import Snapshot from "../modules/snapshot/snapshot";

const ProtectedRoutePlatform = ({ component }) => {
	const userRole = localStorage.getItem("userRole");
	return (
		<PrivateLayout>{userRole === platformLayout.Platform ? component : <NotAuthorize />}</PrivateLayout>
	);
};

const privateRoutes = [
	{
		path: "/app/home",
		exact: true,
		element: <PrivateLayout><Dashboard/></PrivateLayout>
	},
	{
		path: "/app/support",
		exact: true,
		element: <PrivateLayout><Support/></PrivateLayout>
	},
	{
		path: "/app/support/supportDetails",
		exact: true,
		element: <PrivateLayout><SupportDetailsPage/></PrivateLayout>
	},
	{
		path: "/app/profile",
		exact: true,
		element: <PrivateLayout><Profile/></PrivateLayout>
	},
	{
		path: "/app/patient/profile",
		exact: true,
		element: <PrivateLayout><ProfilePatient /></PrivateLayout>
	},
	{
		path: "/app/patient/edit-profile",
		exact: true,
		element: <PrivateLayout><EditPatientProfile /></PrivateLayout>
	},
	{
		path: "/app/patient/patient-profile",
		exact: true,
		element: <PrivateLayout><PatientProfile/></PrivateLayout>
	},
	{
		path: "/app/edit-profile",
		exact: true,
		element: <PrivateLayout><EditProfile/></PrivateLayout>
	},
	{
		path: "/app/snapshot",
		exact: true,
		element: <PrivateLayout><Snapshot/></PrivateLayout>
	},
	{
		path: "/app/activity",
		exact: true,
		element: <PrivateLayout><Activity/></PrivateLayout>
	},
	{
		path: "/app/patient-activity",
		exact: true,
		element: <PrivateLayout><PatientActivity/></PrivateLayout>
	},
	{
		path: "/clinic/patient-list",
		exact: true,
		element: <PrivateLayout><PatientList/></PrivateLayout>
	},
	{
		path: "/clinic/patient-profile",
		exact: true,
		element: <PrivateLayout><PatientProfile/></PrivateLayout>
	},
	{
		path: "/clinic/add-patient",
		exact: true,
		element: <PrivateLayout><AddPatient/></PrivateLayout>
	},
	{
		path: "/app/analytics",
		exact: true,
		element:  <PrivateLayout><Analytics /></PrivateLayout>
	},
	{
		path: "/clinic/calendar",
		exact: true,
		element: <PrivateLayout><Calender/></PrivateLayout>
	},
{
		path: "/app/users",
		exact: true,
		element: <PrivateLayout><Users/></PrivateLayout>
	},
	{
		path: "/patient/application",
		exact: true,
		element: <PrivateLayout><Applications/></PrivateLayout>
	},
	{
		path: "/app/admin-application",
		exact: true,
		element: <PrivateLayout><AdminApplications/></PrivateLayout>
	},
	{
		path: "/app/start-application",
		exact: true,
		element: <PrivateLayout><StartApplication/></PrivateLayout>
	},
	{
		path: "/app/application-detail",
		exact: true,
		element: <PrivateLayout><ApplicationDetailPage/></PrivateLayout>
	},
	{
		path: "/app/repository",
		exact: true,
		element: <PrivateLayout><Repository/></PrivateLayout>
	},
	{
		path: "/app/actions",
		exact: true,
		element: <PrivateLayout><Actions/></PrivateLayout>
	},
	{
		path: "/app/messages",
		exact: true,
		element: <PrivateLayout><Messages/></PrivateLayout>
	},
	//Super admin
	{
		path: "/super-admin/home",
		exact: true,
		element: <ProtectedRoutePlatform component={<AdminDashboard />} />
	},
	{
		path: "/super-admin/organization",
		exact: true,
		element: <ProtectedRoutePlatform component={<Organization/> }/>
	},
	{
		path: "/super-admin/addClinic",
		exact: true,
		element:  <ProtectedRoutePlatform component={<AddClinic/> } />
	},
	{
		path: "/super-admin/addOrganization",
		exact: true,
		element:  <ProtectedRoutePlatform component={<AddOrganization/> } />
	},
	{
		path: "/super-admin/orgViewDetail",
		exact: true,
		element:  <ProtectedRoutePlatform component={<OrganizationViewDetail/> } />
	},
	{
		path: "/super-admin/clinicDetail",
		exact: true,
		element:  <ProtectedRoutePlatform component={<ClinicViewDetail/> } />
	},
	{
		path: "/super-admin/assignuser",
		exact: true,
		element:  <ProtectedRoutePlatform component={<AssignUser/> } />
	},
	{
		path: "/super-admin/users",
		exact: true,
		element:  <ProtectedRoutePlatform component={<Users/> } />
	},
	{
		path: "/super-admin/create-user",
		exact: true,
		element:  <ProtectedRoutePlatform component={<CreateUser/> } />
	},
	{
		path: "/super-admin/workflow",
		exact: true,
		element:  <ProtectedRoutePlatform component={<Workflow/> } />
	},
	{
		path: "/super-admin/clinicslist",
		exact: true,
		element:  <ProtectedRoutePlatform component={<Cliniclisting/> } />
	},
	{
		path: "/super-admin/userslist",
		exact: true,
		element:  <ProtectedRoutePlatform component={<Userslisting/> } />
	},
	{
		path: "/super-admin/messages",
		exact: true,
		element:  <ProtectedRoutePlatform component={<Messages/> } />
	},
	{
		path: "/super-admin/UserDetails",
		exact: true,
		element:  <ProtectedRoutePlatform component={<UserDetails /> } />
	},
	{
		path: "/super-admin/RoleDetails",
		exact: true,
		element:  <ProtectedRoutePlatform component={<RolesDetails /> } />
	},
	{
		path: "/super-admin/analytics",
		exact: true,
		element:  <ProtectedRoutePlatform component={<Analytics /> } />
	},
	{
		path: "/super-admin/user-details",
		exact: true,
		element:  <ProtectedRoutePlatform component={<OrgUserDetails /> } />
	},
	{
		path: "/super-admin/support",
		exact: true,
		element:  <ProtectedRoutePlatform component={<Support/> } />
	},
	{
		path: "/super-admin/create-request",
		exact: true,
		element:  <ProtectedRoutePlatform component={<CreatePlatformRequest /> } />
	},
	{
		path: "/app/snapshot",
		exact: true,
		element: <PrivateLayout><Snapshot/></PrivateLayout>
	},
	{ path: "/*", element: <NotFound/> },
	{ path: "/not-found", element: <NotFound/> }
];
export default privateRoutes;
